import { appSectionData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-[460px]">
            <div className="relative w-full aspect-[3/4] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20a%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%20and%20play%20buttons%2C%20clean%20dark%20UI%20design%20with%20warm%20accent%20highlights%2C%20placed%20on%20a%20minimal%20desk%20with%20soft%20natural%20lighting%2C%20editorial%20product%20photography%20with%20shallow%20depth%20of%20field%2C%20cozy%20ambient%20atmosphere&width=690&height=920&seq=app-mobile-mockup&orientation=portrait"
                alt="天狼影院移动端APP追剧体验"
                className="w-full h-full object-cover object-top"
                title="天狼影院移动端 - 随时随地追剧"
              />
            </div>
          </div>
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              {appSectionData.title}
            </h2>
            <p className="text-sm text-foreground-500 mt-1">{appSectionData.subtitle}</p>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
              {appSectionData.description}
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mt-5">
              {appSectionData.features.map((feature) => (
                <span
                  key={feature}
                  className="px-3 py-1 text-xs font-medium bg-background-200 text-foreground-700 rounded-full whitespace-nowrap"
                >
                  {feature}
                </span>
              ))}
            </div>
            <div className="mt-6 flex justify-center lg:justify-start">
              <a
                href={appSectionData.ctaHref}
                onClick={(e) => {
                  e.preventDefault();
                  const target = document.querySelector(appSectionData.ctaHref);
                  if (target) target.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line text-lg"></i>
                {appSectionData.ctaLabel}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}